module.exports = __webpack_public_path__ + "static/media/Already-Declined.63bc8576.png";